module.exports = __webpack_public_path__ + "img/pic_title_main.9b85d31b.png";